import React, {useEffect} from "react";
import { useTimer  } from 'react-timer-hook';
import {Format2Degits} from "../../utils/format";

const Timer = (expiryTimestamp )=>{
    let time = expiryTimestamp['expiryTimestamp'];
    const {
        seconds,
        minutes,
        hours,
        restart
      } = useTimer({
        time,
        onExpire: () => console.warn("onExpire called")
      });
      useEffect(()=>{
        restart(time);
      },[]);
      
    return(
        <>
        <div id="countdown">
        {
          seconds > 0 || hours > 0 ||  minutes> 0?(
            <>
             <div className="countdown-item">
                <span id="hours">{Format2Degits(hours)}</span>
              </div>
              <span className="countdown-dots">:</span>
              <div className="countdown-item">
                  <span id="minutes">{Format2Degits(minutes)}</span>
              </div>
              <span className="countdown-dots">:</span>
              <div className="countdown-item">
                  <span id="seconds">{Format2Degits(seconds)}</span>
              </div>
            </>
        ):(null)
      }
      </div>
        </>
        
    );
}

const TimerProductDetail = (expiryTimestamp )=>{
    let time = expiryTimestamp['expiryTimestamp'];
    const {
        seconds,
        minutes,
        hours,
        restart
      } = useTimer({
        time,
        onExpire: () => console.warn("onExpire called")
      });
      useEffect(()=>{
        restart(time);
      },[expiryTimestamp]);
      
    return(
        <>
        {
          seconds > 0 || hours > 0 ||  minutes> 0?(
            <div className="detail-time">
                <span>Kết thúc sau &nbsp;</span> 
                <span id="hours"><strong>{Format2Degits(hours)}</strong></span>
                <span className="detail-time-dots">:</span>
                <span id="minutes"><strong>{Format2Degits(minutes)}</strong></span>
                <span className="detail-time-dots">:</span>
                <span id="seconds"><strong>{Format2Degits(seconds)}</strong></span>
                <span className="detail-time-dots"><strong>s</strong></span>
            </div>
          ):(null)
        }
            
        </>
        
    );
}

const TimerLogin = (expiryTimestamp )=>{
  let time = expiryTimestamp;
  const {
      seconds,
      minutes,
      hours,
      restart
    } = useTimer({
      time,
      onExpire: () => console.warn("onExpire called")
    });
    useEffect(()=>{
      restart(time);
    },[]);
    
  return(
      <>
      {Format2Degits(minutes)}:{Format2Degits(seconds)}
      </>
      
  );
}

export {Timer,TimerProductDetail,TimerLogin} 
